import * as React from 'react';

import { pure } from 'recompose';

import type { ApiStatus, ButtonProps } from '@coursera/coursera-ui';
import { ApiButton, Button, color } from '@coursera/coursera-ui';
import { SvgBookmarkFilled } from '@coursera/coursera-ui/svg';

import _t from 'i18n!nls/enterprise-legacy-learner-home';

type Props = {
  btnAttributes?: ButtonProps;
  onClick: () => void;
  apiStatus: ApiStatus;
  canUnselect?: boolean;
  isSelected?: boolean;
  renderNothingIfConditionNotMet?: boolean;
  initialBtnLabel?: JSX.Element | string;
};

const S12nUnselectButton = ({
  btnAttributes = {},
  onClick,
  apiStatus,
  canUnselect,
  isSelected,
  renderNothingIfConditionNotMet,
  initialBtnLabel = _t('Remove from Saved'),
}: Props) => {
  const renderUnselect = isSelected && canUnselect;
  const renderSelected = isSelected && !renderNothingIfConditionNotMet;

  if (renderUnselect) {
    return (
      <ApiButton
        {...btnAttributes}
        iconAttributes={{
          suppressTitle: true,
        }}
        onClick={onClick}
        apiStatus={apiStatus}
        apiStatusAttributesConfig={{
          label: {
            API_BEFORE_SEND: initialBtnLabel,
            API_IN_PROGRESS: _t('Removing...'),
            API_SUCCESS: _t('Removed'),
            API_ERROR: _t('Failed'),
          },
        }}
      >
        <SvgBookmarkFilled
          color={color.primary}
          hoverColor={color.darkPrimary}
          htmlAttributes={{ 'aria-hidden': true }}
        />
      </ApiButton>
    );
  } else if (renderSelected) {
    return <Button {...btnAttributes} type="disabled" label={_t('Selected')} disabled={true} />;
  }
  return null;
};

export default pure(S12nUnselectButton);
